import { FinancialDocumentAttachment } from "@components/documents/FinancialDocumentAttachment/FinancialDocumentAttachment";
import { FinancialDocumentUploadProvider } from "@components/documents/FinancialDocumentUpload/FinancialDocumentUploadProvider";
import { Task } from "@common/types/task";
import { AddDocument } from "@components/documents/FinancialDocumentList/AddDocument";
import { Button } from "@design-system/Button/Button";
import { UploadIcon } from "@icons";
import classNames from "classnames";
import { useTaskDocumentUpload } from "../useTaskDocumentUpload";
import styles from "./TaskDetail.module.scss";

interface TaskDetailDocumentsSectionProps {
    task: Task;
    readonly?: boolean;
}

export const TaskDetailDocumentsSection = ({
    task,
    readonly = false,
}: TaskDetailDocumentsSectionProps) => {
    const {
        handleUploadCompleted,
        attachDocument,
        attachDocuments,
        detachDocument,
        attachedDocumentIds,
    } = useTaskDocumentUpload(task);

    if (readonly) {
        if (!task.financialDocuments?.length) {
            return <p className={styles.detailValue}>-</p>;
        }
        return (
            <div
                className={classNames(
                    styles.blockingTaskList,
                    styles.detailValue,
                )}
            >
                {task.financialDocuments.map((document) => (
                    <FinancialDocumentAttachment
                        key={document.id}
                        financialDocument={document}
                        detachDocument={detachDocument}
                        readonly
                    />
                ))}
            </div>
        );
    }

    return (
        <div
            className={classNames(styles.blockingTaskList, styles.detailValue)}
        >
            <FinancialDocumentUploadProvider
                onCompleted={handleUploadCompleted}
            >
                <AddDocument
                    trigger={
                        <Button
                            variant="link"
                            size="sm"
                            className={styles.addButton}
                            leftIcon={<UploadIcon />}
                        >
                            Upload
                        </Button>
                    }
                    attachDocument={attachDocument}
                    attachDocuments={attachDocuments}
                    attachedDocumentIds={attachedDocumentIds}
                />
            </FinancialDocumentUploadProvider>
            {task.financialDocuments?.map((document) => (
                <FinancialDocumentAttachment
                    key={document.id}
                    financialDocument={document}
                    detachDocument={detachDocument}
                />
            ))}
        </div>
    );
};
